import { ArrayField, ArrayInput, Create, Datagrid, DateField, DateInput, DateTimeInput, Edit, EditButton, ImageField, ImageInput, List, Show, ShowButton, SimpleForm, SimpleFormIterator, SimpleShowLayout, TextField, TextInput } from "react-admin"
import { uploadTransform } from "../lib/admin"


const SERVICE = 'events'

const EventList = () => {
    return (
        <List>
            <Datagrid>
                <TextField source="label" />
                <DateField source="date" />
                <EditButton />
                <ShowButton />
            </Datagrid>
        </List>
    )
}

const EventCreate = () => {
    return (
        <Create transform={uploadTransform('image')}>
            <SimpleForm>
                <TextInput source="label" label="Заголовок" fullWidth />
                <DateInput source="date" label="Дата" fullWidth />
                <ImageInput source="image" label="Изображение">
                    <ImageField source="src" />
                </ImageInput>
                <ArrayInput source="program" label="Программа" >
                    <SimpleFormIterator>
                        <TextInput source="time" fullWidth/>
                        <TextInput multiline source="text" fullWidth/>
                    </SimpleFormIterator>
                </ArrayInput>
                <ArrayInput source="description" label="Описание">
                    <SimpleFormIterator>
                        <TextInput multiline source="text" fullWidth/>
                    </SimpleFormIterator>
                </ArrayInput>
            </SimpleForm>
        </Create>
    )
}

const EventEdit = () => {
    return (
        <Edit transform={uploadTransform('image')}>
            <SimpleForm>
                <TextInput source="label" label="Заголовок" fullWidth/>
                <DateInput source="date" label="Дата" fullWidth/>
                <ImageInput source="image" label="Изображение">
                    <ImageField source="src" />
                </ImageInput>
                <ArrayInput source="program" label="Программа">
                    <SimpleFormIterator>
                        <TextInput source="time" fullWidth/>
                        <TextInput multiline source="text" fullWidth />
                    </SimpleFormIterator>
                </ArrayInput>
                <ArrayInput source="description" label="Описание">
                    <SimpleFormIterator>
                        <TextInput multiline source="text" fullWidth/>
                    </SimpleFormIterator>
                </ArrayInput>
            </SimpleForm>
        </Edit>
    )
}

const EventShow = () => {
    return (
        <Show>
            <SimpleShowLayout>
                <TextField source="label" label="Заголовок" />
                <DateField source="date" label="Дата" />
                <ImageField source="image.src" label="Изображение" />
                <ArrayField source="program" label="Программа">
                    <Datagrid>
                        <TextField source="time" showTime />
                        <TextField multiline source="text" />
                    </Datagrid>
                </ArrayField>
                <ArrayField source="description" label="Описание">
                    <Datagrid>
                        <TextField multiline source="text" />
                    </Datagrid>
                </ArrayField>
            </SimpleShowLayout>
        </Show>
    )
}

export const eventProps = {
    name: SERVICE,
    list: EventList,
    create: EventCreate,
    edit: EventEdit,
    show: EventShow
}
